import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { ServiceCard } from '@/components/frontend/molecules/ServiceCard'
import type { IconName } from '@/components/frontend/atoms/content/IconBox'
import { useTranslation } from '@/hooks/useTranslation'

const SERVICES: { key: string; icon: IconName }[] = [
  { key: 'software', icon: 'code' },
  { key: 'automation', icon: 'workflow' },
  { key: 'ai', icon: 'bot' },
]

const POINTS = ['1', '2', '3'] as const

export const ServicesSection: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Section padding="lg" background="alt" id="servizi">
      <Container>
        <Stack gap="12">
          <SectionIntro label={t('services.label')} title={t('services.heading')} subtitle={t('services.subheading')} />
          <ResponsiveGrid cols="3" gap="4">
            {SERVICES.map(({ key, icon }) => (
              <ServiceCard
                key={key}
                icon={icon}
                title={t(`services.${key}_title`)}
                description={t(`services.${key}_desc`)}
                points={POINTS.map((point) => t(`services.${key}_point_${point}`))}
              />
            ))}
          </ResponsiveGrid>
        </Stack>
      </Container>
    </Section>
  )
}
